import React, { Component } from 'react';
import { Thumbnail, Col, Button, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import LazyLoad from 'react-lazyload';
import { fetchProduct, updateCartProducts, trigOverlay } from '../actions'
import { getMoneyFormat } from '../utils';
class ProductItem extends Component {
    state = {
        amount: 1,
        imgLoaded: false,
        isKg: false,
    }
    onClick() {
        window.open(`/product/${this.props.product.name_en}`)
        // this.props.fetchProduct(this.props.product.name_en)
    }
    componentWillMount() {
        if (this.props.product.unit == 'กิโลกรัม') {
            this.setState({ isKg: true, amount: 0.5 })
        }
    }
    onAddCart(e) {
        e.stopPropagation()
        let bool = true
        if (this.props.product) {
            this.props.product.id ? '' : bool = false
            this.props.product.name_th ? '' : bool = false
            !isNaN(this.props.product.price) ? '' : bool = false
            // !isNaN(this.props.product.reserve_factor) ? '' : bool = false
            // !isNaN(this.props.product.mark_up_factor) ? '' : bool = false
            this.props.product.unit ? '' : bool = false
            this.state.amount ? '' : bool = false
            this.props.product.img_url || this.props.product.img_url_ss ? '' : bool = false
        } else {
            bool = false
        }
        if (bool) {
            let products = localStorage.getItem('cart_products')
            products = JSON.parse(products)
            let product_id = this.props.product.id
            let product_name = this.props.product.name_th
            let product_amount = Number(this.state.amount)
            let product_price_unit = this.props.product.price
            let product_image_url = this.props.product.img_url == undefined ? this.props.product.img_url_ss : this.props.product.img_url
            let product_reserve_factor = this.props.product.reserve_factor
            let product_unit = this.props.product.unit
            if (products != null) {
                if (products[product_id]) {
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: Number(products[product_id]['product_price_unit']),
                        product_amount: Number((Number(products[product_id]['product_amount']) + product_amount).toFixed(12)),
                        product_image_url: product_image_url,
                        product_reserve_factor: product_reserve_factor,
                        product_unit: product_unit
                    }
                } else {
                    products[product_id] = {
                        product_id: product_id,
                        product_name: product_name,
                        product_price_unit: product_price_unit,
                        product_amount: product_amount,
                        product_image_url: product_image_url,
                        product_reserve_factor: product_reserve_factor,
                        product_unit: product_unit
                    }
                }
            } else {
                products = {}
                products[product_id] = {
                    product_id: product_id,
                    product_name: product_name,
                    product_price_unit: product_price_unit,
                    product_amount: product_amount,
                    product_image_url: product_image_url,
                    product_reserve_factor: product_reserve_factor,
                    product_unit: product_unit
                }
            }
            localStorage.setItem('cart_products', JSON.stringify(products))
            this.props.updateCartProducts(products)
            this.props.trigOverlay({ product_name: product_name, product_amount: product_amount, product_unit: product_unit })
        } else {
            console.log('เกิดข้อผิดพลาดในการเพิ่มสินค้า')
        }
    }
    onAmountChange(value) {
        let decimal = (value % 1).toFixed(12)
        decimal = String(Number(decimal))
        let decimal_count = 0
        for (var i = 2; i < decimal.length; i++) {
            decimal_count += 1
        }
        if ((value >= 0 || value == '') && decimal_count < 2) {
            this.setState({ amount: value })
        }
    }
    onIncreaseAmount(e) {
        e.stopPropagation()
        let step = this.state.isKg ? 0.1 : 1
        this.setState({ amount: Number((this.state.amount + step).toFixed(1)) })
    }
    onDecreaseAmount(e) {
        e.stopPropagation()
        let step = this.state.isKg ? 0.1 : 1
        if (Number(this.state.amount) - step > 0) {
            this.setState({ amount: Number((this.state.amount - step).toFixed(1)) })
        }
    }
    onClear() {
        localStorage.removeItem('cart_products')
        // console.log('clear')
    }
    render() {
        var thumbNailclassName
        var outofstockclassName
        var is_out_of_stock = this.props.product.is_out_of_stock
        is_out_of_stock ? thumbNailclassName = 'tcb-product-item gray-scale' : thumbNailclassName = 'tcb-product-item'
        is_out_of_stock ? outofstockclassName = '' : outofstockclassName = 'hidethis'
        if (!this.props.isCarousel) {
            return (
                <Col md={3} sm={3} xs={6} style={{ cursor: 'pointer' }}>
                    <Thumbnail className="tcb-product-item" onClick={() => { this.onClick() }} style={this.state.imgLoaded ? { margin: 5 } : { display: 'none' }} alt={'product_pic'} onLoad={() => { this.setState({ imgLoaded: true }) }} src={this.props.product.img_url_thumbnail}>
                        <div style={{ height: 85 }}>
                            <h5 className="tcb-product-title">{this.props.product.name_th}</h5>

                            {/*<p className="tcb-product-price"><strong>{this.props.product.discount}</strong></p>*/}
                        </div>
                        {!is_out_of_stock ?
                            <Row>
                                <Col xs={12} style={{ padding: 0 }}>
                                    <p className="tcb-product-stdprice">{getMoneyFormat(this.props.product.price)} บาท / {this.props.product.unit}</p>
                                </Col>
                                <Col xs={12} md={8} style={{ padding: 0 }}>
                                    <div className="input-group">
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onDecreaseAmount(e)}>-</Button>
                                        </span>
                                        <input
                                            onClick={e => { e.stopPropagation() }} disabled={is_out_of_stock ? true : false} style={{ width: 100 + '%', marginBottom: 5 }}
                                            className="form-control" value={this.state.amount} onChange={e => this.onAmountChange(e.target.value)} placeholder={'จำนวน'} type='number'
                                            onBlur={() => {
                                                this.state.amount == '' || this.state.amount == 0 ?
                                                    this.setState({ amount: 1 })
                                                    : ''
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onIncreaseAmount(e)}>+</Button>
                                        </span>
                                    </div>
                                </Col>
                                <Col className='hidden-xs' xs={12} md={4} style={{ padding: 0 }}>
                                    <h4 style={{ marginTop: 10, fontSize: 15, textAlign: 'center' }}>{this.props.product.unit}</h4>
                                </Col>
                                <Button className={this.props.event ? 'event-btn' : 'btn-add-to-cart'} disabled={is_out_of_stock || this.state.amount == '' || this.state.amount == 0 ? true : false} style={{ width: 100 + '%', marginBottom: 5, marginTop: 5 }} onClick={e => this.onAddCart(e)}>หยิบใส่ตะกร้า</Button>
                            </Row>
                            :
                            <Row>
                                <h4 style={{ paddingBottom: 52 }} className='product-label-out_of_stock'>สินค้าหมดชั่วคราว</h4>
                                <br />
                            </Row>
                        }
                    </Thumbnail>
                    <Thumbnail className="tcb-product-item" onClick={() => { this.onClick() }} style={!this.state.imgLoaded ? { margin: 5 } : { display: 'none' }} src='../../static/images/placeholderthumbnail.jpg'>
                        <div style={{ height: 85 }}>
                            <h5 className="tcb-product-title">{this.props.product.name_th}</h5>

                            {/*<p className="tcb-product-price"><strong>{this.props.product.discount}</strong></p>*/}
                        </div>
                        {!is_out_of_stock ?
                            <Row>
                                <Col xs={12} style={{ padding: 0 }}>
                                    <p className="tcb-product-stdprice">{getMoneyFormat(this.props.product.price)} บาท / {this.props.product.unit}</p>
                                </Col>
                                <Col xs={12} md={8} style={{ padding: 0 }}>
                                    <div className="input-group">
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onDecreaseAmount(e)}>-</Button>
                                        </span>
                                        <input
                                            onClick={e => { e.stopPropagation() }} disabled={is_out_of_stock ? true : false} style={{ width: 100 + '%', marginBottom: 5 }}
                                            className="form-control" value={this.state.amount} onChange={e => this.onAmountChange(e.target.value)} placeholder={'จำนวน'} type='number'
                                            onBlur={() => {
                                                this.state.amount == '' || this.state.amount == 0 ?
                                                    this.setState({ amount: 1 })
                                                    : ''
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onIncreaseAmount(e)}>+</Button>
                                        </span>
                                    </div>
                                </Col>
                                <Col className='hidden-xs' xs={12} md={4} style={{ padding: 0 }}>
                                    <h4 style={{ marginTop: 10, fontSize: 15, textAlign: 'center' }}>{this.props.product.unit}</h4>
                                </Col>
                                <Button className={this.props.event ? 'event-btn' : 'btn-add-to-cart'} disabled={is_out_of_stock || this.state.amount == '' || this.state.amount == 0 ? true : false} style={{ width: 100 + '%', marginBottom: 5, marginTop: 5 }} onClick={e => this.onAddCart(e)}>หยิบใส่ตะกร้า</Button>
                            </Row>
                            :
                            <Row>
                                <h4 style={{ paddingBottom: 52 }} className='product-label-out_of_stock'>สินค้าหมดชั่วคราว</h4>
                                <br />
                            </Row>
                        }
                    </Thumbnail>
                </Col>
            )
        } else {
            return (
                <div style={{ cursor: 'pointer' }}>
                    <Thumbnail className="tcb-product-item" onClick={() => { this.onClick() }} style={{ margin: 5 }} alt={'product_pic'} src={this.props.product.img_url_thumbnail}>
                        <div style={{ height: 85 }}>
                            <h5 className="tcb-product-title">{this.props.product.name_th}</h5>

                        </div>
                        {!is_out_of_stock ?
                            <Row>
                                <Col xs={12} style={{ padding: 0 }}>
                                    <p className="tcb-product-stdprice">{getMoneyFormat(this.props.product.price)} บาท / {this.props.product.unit}</p>
                                </Col>
                                <Col xs={12} md={8} style={{ padding: 0 }}>
                                    <div className="input-group">
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onDecreaseAmount(e)}>-</Button>
                                        </span>
                                        <input
                                            onClick={e => { e.stopPropagation() }} disabled={is_out_of_stock ? true : false} style={{ width: 100 + '%', marginBottom: 5 }}
                                            className="form-control" value={this.state.amount} onChange={e => this.onAmountChange(e.target.value)} placeholder={'จำนวน'} type='number'
                                            onBlur={() => {
                                                this.state.amount == '' || this.state.amount == 0 ?
                                                    this.setState({ amount: 1 })
                                                    : ''
                                            }}
                                        />
                                        <span className="input-group-btn">
                                            <Button type="button" style={{
                                                marginBottom: 4,
                                                border: 'none !important',
                                                color: '#ffffff !important',
                                                background: '#f57224 !important',
                                                background: '-webkit-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-o-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: '-moz-linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                background: ' linear-gradient(263deg, #f5ac24, #f57224) !important',
                                                height: 34
                                            }} className="btn" onClick={(e) => this.onIncreaseAmount(e)}>+</Button>
                                        </span>
                                    </div>
                                </Col>
                                <Col className='hidden-xs' xs={12} md={4} style={{ padding: 0 }}>
                                    <h4 style={{ marginTop: 10, fontSize: 15, textAlign: 'center' }}>{this.props.product.unit}</h4>
                                </Col>
                                <Button className={this.props.event ? 'event-btn' : 'btn-add-to-cart'} disabled={is_out_of_stock || this.state.amount == '' || this.state.amount == 0 ? true : false} style={{ width: 100 + '%', marginBottom: 5, marginTop: 5 }} onClick={e => this.onAddCart(e)}>หยิบใส่ตะกร้า</Button>
                            </Row>
                            :
                            <Row>
                                <h4 style={{ paddingBottom: 52 }} className='product-label-out_of_stock'>สินค้าหมดชั่วคราว</h4>
                                <br />
                            </Row>
                        }
                    </Thumbnail>
                </div>
            )
        }
    }
}
export default connect(null, { fetchProduct, updateCartProducts, trigOverlay })(ProductItem)


// WEBPACK FOOTER //
// ./src/components/product_item.js